import * as React from 'react';
import { useState} from 'react'
import AvailabilityList from './AvailabilityList';
import useWindowSize from '../../utils/useWindowSize';
import { Card, Button, Alert, Form, FormGroup } from 'react-bootstrap'
import { useApprovedContext } from '../../contexts/ApprovedContext';
import { DayPicker } from 'react-day-picker';
import 'react-day-picker/dist/style.css';
import { useAuth } from '../../contexts/AuthContext';

export default function Availability() {
  const windowSize = useWindowSize();
  const [error, setError] = useState("");
  const [ updateCount, setUpdateCount ] = useState(0);
  const { addAvailability } = useApprovedContext();
  const [selected, setSelected] = useState<Date | undefined>(undefined);
  const { currentUserInfo } = useAuth();

  const fromDate = new Date();
  const toDate = new Date();

  if (currentUserInfo?.isDriver) {
    toDate.setDate(toDate.getDate() + 60);
  } else {
    toDate.setDate(toDate.getDate() + 14);
  }


  async function handleNewAvailability(e : React.FormEvent<HTMLFormElement>): Promise<void> {
    e.preventDefault();
    setError("")
    if (!selected) return;
    addAvailability(selected)
      .then(() => {
        setUpdateCount(updateCount + 1);
      })
//      .catch((error) => {setError(error)});
  }

  function getNumberOfMonths(): number {
    if (windowSize.width < 768) {return 1};

    // This will either be 1 2 or 3, dependent on how far into the month we are, and if the user is a driver or virgin
    let idealNum = (toDate.getMonth  () + (toDate.getFullYear () * 12)) - (fromDate.getMonth() + (fromDate.getFullYear() * 12)) + 1;

    if (windowSize.width < 944) {return Math.min(2, idealNum)};

    return idealNum;
  }

  return (
    <Card>
      <Card.Header>
        <h2>Your Availability</h2>
        <p>Keep your availability up-to-date for the next two weeks.<br />Regular flying on Wednesdays, Saturdays, and Sundays, but other days are possible.</p>
      </Card.Header>
      <Card.Body>
        {error && <Alert variant="danger">{error}</Alert>}
          <Form onSubmit={handleNewAvailability}>
            <FormGroup id="date" className="d-flex justify-content-center">
              <DayPicker
                mode="single"
                required
                selected={selected}
                onSelect={setSelected}
                fromDate={fromDate}
                toDate={toDate}
                numberOfMonths={getNumberOfMonths()}
              />
            </FormGroup>
            <Button className='w-100 mt-3' type="submit">Add availability</Button>
          </Form>
        <AvailabilityList setError={setError} updateCount={updateCount} setUpdateCount={setUpdateCount} />
      </Card.Body>
    </Card>
  )
}
